import React from 'react';

import { makeStyles } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';
import Box from '@mui/material/Box';

import withReadModeField from 'components/shared/CRUD/components/InnerPage/components/withReadModeField';

import { CodeField, NameField } from '../FormFields';
import SurchargeMaintenanceDetailsTable from './SurchargesMaintenanceDetailsTable';

const useStyles = makeStyles(() => ({
  root: {
    flexDirection: 'column',
    flex: 1
  }
}));

interface Props {
  setDeletedIds: React.Dispatch<React.SetStateAction<number[]>>;
}

const CodeFieldWithReadMode = withReadModeField(CodeField);
const NameFieldWithReadMode = withReadModeField(NameField);

const SurchargesMaintenanceFormFields: React.FC<Props> = ({
  setDeletedIds
}) => {
  const classes = useStyles();
  const { control } = useFormContext();
  const { t } = useTranslation('common');

  return (
    <Box display="flex" className={classes.root}>
      <Box mb={2.5} sx={{ width: '100%' }}>
        <Grid container mb={2.5} rowSpacing={2} columnSpacing={2}>
          <Grid xs={6} item={true}>
            <CodeFieldWithReadMode
              name="code"
              label={t('surchargesMaintenance.grid.code')}
            />
          </Grid>

          <Grid xs={6} item>
            <NameFieldWithReadMode
              control={control}
              name="name"
              label={t('surchargesMaintenance.grid.name')}
            />
          </Grid>
        </Grid>
      </Box>

      <SurchargeMaintenanceDetailsTable setDeletedIds={setDeletedIds} />
    </Box>
  );
};

export default SurchargesMaintenanceFormFields;
